import {
  LandingNav,
  SupplierNav,
  GateManagementNav,
  AccountNav,
  MarketplaceOnlyGmsUserNav
} from "./navs";
import {hasAdminAccess} from "../../util/AccountUtils";

const GATE_MANAGEMENT_SUBNAV = {
  path: 'gate-management', label: 'Gate Management',
  submenus: [
    GateManagementNav.CHECK_IN,
    GateManagementNav.SUPPLIER_INVENTORY,
    GateManagementNav.SUPPLIER_INTERCHANGES,
    GateManagementNav.SUPPLIER_ACTIVITY_SUMMARY,
  ]
}

const FINANCES_SUBNAV = {
  path: 'finances', label: 'Finances',
  submenus: [
    SupplierNav.SUPPLIER_INVOICES,
    SupplierNav.READY_FOR_PAYOUT,
    SupplierNav.SUPPLIER_PAYOUTS,
  ]
}

const makeBookingsSubmenu = (...additionalItems: typeof SupplierNav[keyof typeof SupplierNav][]) => {

  const subMenus = Array.prototype.concat([
    SupplierNav.APPROVALS,
    SupplierNav.SUPPLIER_BOOKINGS,
  ], additionalItems)

  return {
    path: 'bookings',
    label: 'Bookings',
    badge: undefined,
    submenus: subMenus
  }
}

const makeFinancesSubMenu = (user: {
  userType: string
}, ...additionalItems: typeof SupplierNav[keyof typeof SupplierNav][]) => {
  const newFinancesSubnav = Object.assign({}, FINANCES_SUBNAV); // Copy default subnav vales

  if (hasAdminAccess(user)) {
    additionalItems.push(SupplierNav.SUPPLIER_ACCOUNTS_RECEIVABLE);
  }
  newFinancesSubnav.submenus = newFinancesSubnav.submenus.concat(additionalItems);
  return newFinancesSubnav;
};

export const makeSupplierOwnerGMSProNav = (user: { userType: string }) => {
  return [
    LandingNav.SEARCH,
    makeGateManagementSubmenu(
      GateManagementNav.SUPPLIER_PENDING_INVENTORY_ACTIVITY,
      GateManagementNav.INVENTORY_CORRECTION
    ),
    makeBookingsSubmenu(SupplierNav.SUPPLIER_BOOKED_SPACE_CALENDAR),
    makeFinancesSubMenu(user, SupplierNav.PARTNER_SUBSCRIPTIONS),
    LandingNav.RESOURCES_AS_SUPPLIER,
    LandingNav.CONTACT
  ];
};

export const makeSupplierOwnerGMSLiteNav = (user: { userType: string }) => {
  return [
    LandingNav.SEARCH,
    makeGateManagementSubmenu(GateManagementNav.INVENTORY_CORRECTION),
    makeBookingsSubmenu(SupplierNav.SUPPLIER_BOOKED_SPACE_CALENDAR),
    makeFinancesSubMenu(user, SupplierNav.PARTNER_SUBSCRIPTIONS),
    LandingNav.RESOURCES_AS_SUPPLIER,
    LandingNav.CONTACT
  ];
};

export const makeSupplierMarketPlaceOnlyNav = (user: { userType: string }) => {
  return [
    LandingNav.SEARCH,
    SupplierNav.GMS_LANDING,
    makeBookingsSubmenu(),
    makeFinancesSubMenu(user),
    LandingNav.RESOURCES_AS_SUPPLIER,
    LandingNav.CONTACT
  ];
};

const makeGateManagementSubmenu = (...additionalItems: typeof GateManagementNav[keyof typeof GateManagementNav][]) => {
  const newGateManagementSubmenu = Object.assign({}, GATE_MANAGEMENT_SUBNAV);
  newGateManagementSubmenu.submenus = newGateManagementSubmenu.submenus.concat(additionalItems);
  return newGateManagementSubmenu;
};

export const makeGateManagerNav = () => {
  return [
    makeGateManagementSubmenu(GateManagementNav.INVENTORY_CORRECTION),
    SupplierNav.APPROVALS,
    LandingNav.RESOURCES_AS_SUPPLIER,
    LandingNav.CONTACT
  ];
}

export const SUPPLIER_GATE_CLERK_NAV = [
  GateManagementNav.CHECK_IN,
  GateManagementNav.SUPPLIER_INVENTORY,
  GateManagementNav.SUPPLIER_INTERCHANGES,
  GateManagementNav.SUPPLIER_ACTIVITY_SUMMARY,
  LandingNav.RESOURCES_AS_SUPPLIER
]

export const MARKETPLACE_ONLY_GATE_USER_NAV = [
  MarketplaceOnlyGmsUserNav.GMS_UPGRADE,
  SupplierNav.GMS_LANDING,
  LandingNav.CONTACT,
  AccountNav.SIGN_OUT
]
